import React, { Suspense, lazy, useState } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoutes";
//layouts
import Main from "./../front/layouts/main";
import AuthUser from "./../front/Auth/AuthUser";
import UnAuthorize from "../front/components/Common/unAuthorizedUser";
import NotFound from "../front/components/Common/notFound";
import { routeConfig } from "./routConfig";
import "./../front/css/bootstrap-original.css";
import "./../front/css/custom.css";
import "./../front/css/icons.min.css";
// Front Website Pages
const Home = lazy(() => import("./../front/pages/home"));
const Contact = lazy(() => import("./../front/pages/contact"));
const Login = lazy(() => import("./../front/Auth/Login"));
const DashBoard = lazy(() => import("./../front/components/dashBoard"));
const DashBoard1 = lazy(() => import("./../front/components/dashBoard"));
const Companies = lazy(
  () => import("./../front/components/Client/Companies/Companies")
);
const Vendors = lazy(
  () => import("./../front/components/Client/StoreVendor/Vendors")
);
const Runner = lazy(() => import("./../front/components/Client/Runner/Runner"));
const ExpenseType = lazy(
  () => import("./../front/components/Client/ExpenseTypes/ExpenseType")
);
const SalesRep = lazy(
  () => import("./../front/components/Client/SalesRep/SalesRep")
);
const Contractor = lazy(
  () => import("./../front/components/Client/Contractors/Contractor")
);
const User = lazy(() => import("./../front/components/Client/Users/User"));
const ResetPassword = lazy(
  () => import("./../front/components/Client/Users/ResetPassword")
);
const Customers = lazy(
  () => import("./../front/components/Client/Customers/Customers")
);
const MainDashBoard = lazy(() => import("./../front/components/dashBoard"));
const Detail = lazy(
  () => import("./../front/components/Client/Customers/Detail")
);
const Contract = lazy(
  () => import("./../front/components/Client/Contracts/Contracts")
);
const ContractorBills = lazy(
  () => import("./../front/components/Client/ContractorBill/ContractorBills")
);
const SalesPersonCommission = lazy(
  () =>
    import(
      "./../front/components/Client/SalesPersonCommissions/SalesPersonCommission"
    )
);
const Index = lazy(
  () => import("./../front/components/Client/AccountPayable/Index")
);
const SalesProfitReport = lazy(
  () => import("./../front/components/Client/Reports/SalesProfitReport")
);
const AdminUsers = lazy(
  () => import("../front/components/Admin/AdminUsers/AdminUser")
);
const AdminNormalUser = lazy(
  () => import("./../front/components/Admin/Users/User")
);
const LogOut = lazy(() => import("./../front/Auth/Logout"));
const TokenexpireAlert = lazy(
  () => import("./../front/components/Common/tokenexpireAlert")
);
const ForGotPassword = lazy(
  () => import("./../front/components/Client/Users/ForGotPassword")
);

// Auth Pages

// CRM Pages

const Routers = () => {
  //interface RouteObject {

  //     key: number;
  //     element?: React.ReactNode;
  //     path?: string;
  //     Roles: Array<string>;
  //}
  //const routesConfig: RouteObject[] = [
  //    {
  //        key: 1,
  //        element: <DashBoard />,
  //        path: '/dashboard',
  //        Roles: ["Admin"]

  //    },
  //    {
  //        key:2,
  //        element: <DashBoard1 />,
  //        path: '/dashboard1',
  //        Roles: ["Project Manager"]

  //    },

  //];

  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <div
            className="spinner-grow text-primary spinnermain"
            role="status"
          ></div>
        }
      >
        <Routes>
          <Route element={<Main />}>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/Login" element={<Login />} />
            <Route path="/LogOut" element={<LogOut />} />
            <Route path="/User/ResetPassword" element={<ResetPassword />} />
            <Route path="/User/ForGotPassword" element={<ForGotPassword />} />
            <Route path="/Unauthorized" element={<UnAuthorize />} />
            <Route path="/TokenExpired" element={<TokenexpireAlert />} />

            <Route path="*" element={<NotFound />} />
          </Route>

          {/*<Route path='/Dashboard1' element={<DashBoard1 />} />*/}
          {/*<Route path='/Dashboard' element={<DashBoard />} />*/}
          {/*<Route path='/Companies' element={<Companies />} />*/}
          {/*<Route path='/Vendors' element={<Vendors />} />*/}
          {/*<Route path='/Runners' element={<Runner />} />*/}
          {/*<Route path='/ExpenseTypes' element={<ExpenseType />} />*/}
          {/*<Route path='/SalesRep' element={<SalesRep />} />*/}
          {/*<Route path='/Contractor' element={<Contractor />} />*/}
          {/*<Route path='/User' element={<User />} />*/}
          {/*<Route path='/User/ResetPassword' element={<ResetPassword />} />*/}
          {/*<Route path='/Customers' element={<Customers />} />*/}
          {/*<Route path='/Customers/Detail/:customerId' element={<Detail />} />*/}
          {/*<Route path='/ContractorBill' element={<ContractorBills />} />*/}
          {/*<Route path='/SalesPersonCommission' element={<SalesPersonCommission />} />*/}
          {/*<Route path='/Contract' element={<Contract />} />*/}
          {/*<Route path='/AccountPayable' element={<Index />} />*/}
          {/*<Route path='/SalesProfitReport' element={<SalesProfitReport />} />*/}
          {/*<Route path='/Admin/AdminUser' element={<AdminUsers />} />*/}
          {/*<Route path='/Admin/User' element={<AdminNormalUser />} />*/}

          {routeConfig.map((route) => (
            <Route element={<ProtectedRoute RolesArray={route.Roles} />}>
              <Route
                key={route.key}
                path={route.path}
                element={route.element}
              />
            </Route>
          ))}
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default Routers;
